import { render, staticRenderFns } from "./DecimalIcon.vue?vue&type=template&id=33ce3f22&"
import script from "./DecimalIcon.vue?vue&type=script&lang=js&"
export * from "./DecimalIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports